export default function formattedCreditsWithHoursShort(credit: number): string {
  const hours = Math.floor(credit / 3600)
  if (hours > 0) {
    return `${hours}h ${Math.floor((credit - hours * 3600) / 60)}m ${Math.round(credit % 60)}s`
  } else {
    return `${Math.floor(credit / 60)}m ${Math.round(credit % 60)}s`
  }
}
